module.exports = __webpack_public_path__ + "static/media/laser_LENS_green.4972892b.png";